<template>
  <main>
    <!-- Start breadcumb Area -->
    <div class="page-area">
      <div class="breadcumb-overlay"></div>
      <div class="container">
        <div class="row">
          <div class="col-md-12 col-sm-12 col-xs-12">
            <div class="breadcrumb text-center">
              <div class="section-headline white-headline">
                <h3>新闻中心</h3>
              </div>
              <ul class="breadcrumb-bg">
                <li>新闻中心</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- End breadcumb Area -->

    <!--Blog Area Start-->
    <div class="blog-area bg-color-2 page-padding-2" v-loading="loading">
      <div class="container" id="container">
        <div class="row">
          <div class="blog-grid">
            <div class="col-md-12 col-sm-12 col-xs-12">
              <div class="blog-right-column">
                <section
                  class="single-blog"
                  v-for="(i, index) in newsList"
                  :key="index"
                >
                  <div class="blog-image">
                    <a class="image-scale" @click="lookwz(i.id)">
                      <img draggable="false" :src="i.cover_picture" alt />
                    </a>
                  </div>
                  <div class="blog-content">
                    <div class="blog-meta">
                      <span class="date-type"
                        >{{
                          i.created_at.split("T").join(" ").split("+").shift()
                        }}
                        | {{ i.article_author }}</span
                      >
                    </div>
                    <a @click="lookwz(i.id)">
                      <h4>{{ i.article_title }}</h4>
                    </a>
                    <p>{{ i.article_summary }}</p>
                  </div>
                </section>
              </div>
            </div>
          </div>
        </div>
        <!-- End row -->
      </div>
    </div>
    <el-pagination
      @current-change="currentChangeHandle"
      :current-page="currentPage"
      layout=" prev, pager, next"
      :total="total"
      v-if="total"
      background
    >
    </el-pagination>
  </main>
</template>
<script>
export default {
  metaInfo: {
    title: '海星云-游戏资讯-游戏新闻',
    meta: [
      {
        name: 'keywords',
        content: '游戏资讯,游戏攻略,云游戏,海星云'
      },
      {
        name: 'description',
        content: '海星云游戏资讯攻略内容，帮助玩家了解更多游戏咨询内容，海星云支持全平台畅玩，玩家不用升级电脑即可畅玩游戏大作'
      }
    ]
  },
  data () {
    return {
      total: 0,
      currentPage: 1,
      newsList: [],
      loading: false
    }
  },
  methods: {
    // 跳转文章详情页
    lookwz (id) {
      this.$router.push({
        path: './Article_details',
        query: {
          id: id
        }
      })
    },
    currentChangeHandle (val) {
      this.currentPage = val
      console.log(val)
      sessionStorage.setItem('currentPage', val)
      this.getNewSList(val)
    },
    getNewSList (page) {
      this.loading = true
      this.http.queryNews({type: '1400', page: page}).then(res => {
        this.loading = false
        this.total = res.data.data.total_page * 10
        this.newsList = res.data.data.article_list
        this.$scrollTo()
      })
    }
  },

  mounted () {
    if (sessionStorage.getItem('detail')) {
      // console.log(Number(sessionStorage.getItem("currentPage")));
      // 如果有这个就读取缓存里面的数据
      this.currentPage = Number(sessionStorage.getItem('currentPage'))
    } else {
      this.currentPage = 1
      // 这个主要是从其他页面第一次进入列表页，清掉缓存里面的数据
      sessionStorage.removeItem('currentPage')
    }
    this.getNewSList(this.currentPage)
  },
  destroyed () {
    sessionStorage.removeItem('detail')
    this.loading = false
  }
}
</script>

<style lang="scss" scoped>
/deep/ .el-pagination {
  text-align: center;
  background: #100e2e;
  padding: 25px 5px;
  .active {
    background-color: #f4c91d !important;
  }
  .el-pager li:not(.disabled):hover {
    // color: #f4c91d !important;
  }
}
/deep/ .el-loading-mask {
  background: none;
  .el-loading-spinner .path {
    stroke: #f4c91d;
  }
}
#container {
  min-height: 200px;
}
@media (max-width: 960px) {
  #container {
    min-height: auto;
  }
  .single-blog {
    display: flex;
    flex-direction: column;
    height: auto;
    .blog-image {
      width: 100%;
    }
    .blog-content {
      width: 100%;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Blog.vue